/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useState,useRef } from "react";
import _, { set } from "lodash";
import { Form, Formik, FormikProps } from "formik";
import { questions, initialValues } from "./create-lead-popup.constant";
import closeIcon from "../../../../assets/icons/closeIcon.svg";
import leadDecagramIcons from "../../../../assets/icons/leadDecagramIcons.svg";
import "./create-lead-popup.scss";
import { ConfirmationPopup } from "../../../../common/components";
import confirmationIcon from "../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg"
import { leadCreate } from "../../../../api/lead";
import infoIcon from "../../../../assets/icons/info-icon.svg"

interface FormValues {
  title: string;
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  secondaryEmail: string;
  fax: string;
  website: string;
  numEmployees: string;
  annualRevenue: string;
  interestedProduct: string;
  socialLeadId: string;
  streetLine1: string;
  streetLine2: string;
  description: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  primaryPhoneNumber: string;
  secondaryPhoneNumber: string;
  imageUrl: null;
  industry: string;
  designation: string;
  middleName: string;
  age: string;
  leadValue: string;
}

const CreateLeadPopup = (props: any) => {
  const { setIsShowCreateLeadSection, setCreateLeadInitialValues,setLoading, setAlertMessage, setAlertType, setAlertOpen, updateLeadList } = props;
  const [isSpeechRecognition, setIsSpeechRecognition] = useState<any>(false);
  const [questionsInformation, setQuestionsInformation] =
    useState<any>(questions);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState<boolean>(false);
  const specialVoiceCommands = [
    "skip",
    "next",
    "previous",
    "retry",
    "cancel",
    "save",
    "submit",
    "skip.",
    "next.",
    "previous.",
    "retry.",
    "cancel.",
    "save.",
    "submit."
  ];
  const formRef = useRef<FormikProps<FormValues>>(null);
  const [headerTextOptions, setHeaderTextOptions] = useState<string>("Next, Cancel & Retry.");

  const handleVoiceUpdate = (
    questionData: any,
    index: number,
    setFieldValue: any,
    formValues?: any,
  ) => {
    setIsSpeechRecognition(true);
    if (!(window as any).webkitSpeechRecognition) {
      alert("Speech recognition is not supported in your browser.");
      setIsSpeechRecognition(false);
      return;
    }
    const recognition = new (window as any).webkitSpeechRecognition();
    recognition.start();
    recognition.onresult = (event: any) => {
      const value = event.results[0][0].transcript;
      console.log("Voice Input value:", value);
      setErrorMessage("")
      if (value) {
        const updatedQuestions = questionsInformation?.map(
          (question: any, i: number) => {
            if (i === index) {
              if (value?.toLowerCase() === "skip" || value?.toLowerCase() === "skip.") {
                setErrorMessage("");
                if (questionData?.isRequired) {
                  setErrorMessage(`${_.startCase(questionData?.fieldKey)} is mandatory and cannot be skipped.`);
                } else {
                  handleSkipButtonClick(index);
                }
                setIsSpeechRecognition(false);
                return;
              }
              if (value?.toLowerCase() === "next" || value?.toLowerCase() === "next.") {
                //if the field is not required or if the field is required and has a value, then only go to next question
                setErrorMessage("");
                if (!questionData?.isRequired || (questionData?.isRequired && questionData?.value)) {
                  setErrorMessage("");
                  setIsSpeechRecognition(false);
                  handleNextButtonClick(index);
                } else {
                  setErrorMessage(`Please provide a response for ${questionData?.question} before proceeding.`);
                  setIsSpeechRecognition(false);
                }
                return;
              }
              if (value?.toLowerCase() === "previous" || value?.toLowerCase() === "previous.") {
                setErrorMessage("");
                if(index > 0){
                  handlePreviousButtonClick(index);
                  setIsSpeechRecognition(false);
                }
                return;
              }
              if (value?.toLowerCase() === "retry" || value?.toLowerCase() === "retry.") {
                // Clear field and restart mic
                setErrorMessage("");
                setFieldValue(questionData?.fieldKey, "");
                const updatedQuestions = questionsInformation.map((q:any, i: number) =>
                  i === index ? { ...q, value: "", isShowNextButton: false } : q
                );
                setQuestionsInformation(updatedQuestions);
                return;
              }
              if (value?.toLowerCase() === "cancel" || value?.toLowerCase() === "cancel.") {
                setErrorMessage("");
                setIsCancelPopupOpen(true);
                setIsSpeechRecognition(false);
                return;
              }
              if (value?.toLowerCase() === "save" || value?.toLowerCase() === "submit" || value?.toLowerCase() === "save." || value?.toLowerCase() === "submit.") {
                setErrorMessage("");
                const mandatoryFilled = ["firstName", "lastName", "email"].every(fieldKey =>
                  Boolean(
                    questionsInformation.find((q:any) => q?.fieldKey === fieldKey)?.value?.trim()
                  )
                );
                if (mandatoryFilled && !errorMessage) {
                  handleSave(formValues);
                } else {
                  setErrorMessage("Please provide details for mandatory fields: first name, last name, email.");
                }
                setIsSpeechRecognition(false);
                return;
              }

              let updatedValue;
              setErrorMessage("");
              // Input formatting based on type
              if (questionData?.type === "number") {
                if (questionData?.fieldKey === "numEmployees") {
                  updatedValue = value.replace(/\D/g, "").substring(0, 7);
                } else {
                  updatedValue = value.replace(/\D/g, "");
                }
              } else if (questionData?.type === "email") {
                console.log('email question is called', value)
                updatedValue = value
                  .replace("at the rate", "@")
                  .replace(/\bat the\b/g, "@") //to replace even there at the word
                  .replace(/\bat\b/g, "@") //to replace even there at word
                  .replace("Gmail", "gmail")
                  .replaceAll(" ", "");
              } else if (questionData?.type === "text") {
                updatedValue = value.replace(/[0-9]/g, " ").substring(0, 50);
              } else if (questionData?.type === "mobileNumber") {
                updatedValue = value.replace(/\D/g, "").substring(0, 10);
              } else if (questionData?.type === "website") {
                updatedValue = value.replace("dot", ".").replaceAll(" ", "");
              } else if (questionData?.type === "textNumber") {
                updatedValue = value;
              } else if (questionData?.type === "age") {
                console.log('age question is called', value)
                const ageValue = value.replace(/\D/g, "");
                console.log('ageValue after formatting', ageValue)
                updatedValue = Number(ageValue)>0 && Number(ageValue)<=120 ? ageValue : questionData?.values
              } else if (questionData?.type === "interestedProductDropdown") {
                 const interestedProductValueTemp = value.replace(/[0-9]/g, " ").substring(0, 50);
                if(["at need"]?.includes(interestedProductValueTemp)){
                  updatedValue = "At-Need";
                }
                if(["pre need", "preneed", "need"]?.includes(interestedProductValueTemp)){
                  updatedValue = "Pre-Need";
                }
                if(["consultation"]?.includes(interestedProductValueTemp)){
                  updatedValue = "Consultation";
                }
                if(["miscellaneous"]?.includes(interestedProductValueTemp)){
                  updatedValue = "Miscellaneous";
                }
              }
              setFieldValue(questionData?.fieldKey, updatedValue);
              return {
                ...question,
                value: updatedValue,
                isShowNextButton: true,
                isShowSkipButton: false,
              };
            }
            return question;
          },
        );
        if (value?.toLowerCase()?.trim() && !specialVoiceCommands.includes(value?.toLowerCase()?.trim())) {
          setQuestionsInformation(updatedQuestions);
        }
        setIsSpeechRecognition(false);
      }
    };
    recognition.onspeechend = () => {
      setIsSpeechRecognition(false);
      recognition.stop();
    };

    recognition.onerror = () => {
      setIsSpeechRecognition(false);
    };
  };

  const handleNextButtonClick = (index: number) => {
    setErrorMessage("");
    const updatedQuestions = questionsInformation?.map(
      (question: any, i: number) => {
        if (index === i) {
          return { ...question, isShowSection: false, isShowNextButton: false };
        } else if (index + 1 === i) {
          return {
            ...question,
            isShowSection: true,
            isShowNextButton: question?.isRequired
              ? question?.value
                ? true
                : false
              : false,
            isShowSkipButton: question?.isRequired ? false : true,
          };
        } else {
          return question;
        }
      },
    );
    setQuestionsInformation(updatedQuestions);
  };

  const handlePreviousButtonClick = (index: number) => {
    setErrorMessage("");
    const updatedQuestions = questionsInformation?.map(
      (question: any, i: number) => {
        if (index === i) {
          return { ...question, isShowSection: false, isShowNextButton: false };
        } else if (index - 1 === i) {
          return {
            ...question,
            isShowSection: true,
            isShowNextButton: true,
            isShowSkipButton: false,
          };
        } else {
          return question;
        }
      },
    );
    setQuestionsInformation(updatedQuestions);
  };

  const handleSkipButtonClick = (index: number) => {
    setErrorMessage("");
    const updatedQuestions = questionsInformation?.map(
      (question: any, i: number) => {
        if (index === i) {
          return { ...question, isShowSection: false, isShowNextButton: false, value: "" };
        } else if (index + 1 === i) {
          return {
            ...question,
            isShowSection: true,
            isShowNextButton: false,
            isShowSkipButton: question?.isRequired ? false : true,
          };
        } else {
          return question;
        }
      },
    );
    setQuestionsInformation(updatedQuestions);
  };

  const onSubmit = async (values: any) => {
    setCreateLeadInitialValues(values);
    props?.onClose();
    setIsShowCreateLeadSection(true);
  };

  const handleSave = async (values: any) => {
    setLoading?.(true);
    try {
      const formData = new FormData();
      const leadDetails = {
        company: values.company,
        title: values.title,
        firstName: values.firstName,
        lastName: values.lastName,
        primaryEmail: values.email,
        secondaryEmail: values.secondaryEmail || null,
        primaryPhoneNumber: values?.primaryPhoneNumber || null,
        secondaryPhoneNumber: values?.secondaryPhoneNumber || null,
        website: values.website || null,
        leadSource: "Manual",
        leadStatus: "New Lead",
        faxNumber: values.fax || null,
        industry: values.industry || null,
        numberOfEmployees: values.numEmployees
          ? Number(values.numEmployees)
          : null,
        annualRevenue: values.annualRevenue || null,
        interestedProducts: null,
        confidenceScore: null,
        socialLeadId: values.socialLeadId || null,
        description: values.description || null,
        designation: values.designation || null,
        middleName: values.middleName || null,
        age: parseInt(values.age || 0) || null,
        leadValue: values.leadValue || null,
        maritalStatus: null,
      };

      Object.entries(leadDetails).forEach(([key, value]) => {
        if (value) formData.append(key, value);
      });

      [
        "streetLine1",
        "streetLine2",
        "city",
        "state",
        "country",
        "zipcode",
      ].forEach((field) => {
        if (values[field]) {
          formData.append(
            `address[${field.replace("Address", "")}]`,
            values[field]
          );
        }
      });
      if (values.imageUrl instanceof File) {
        formData.append("leadImg", values.imageUrl);
      }

      const response = await leadCreate(formData);

      if (response.data.success) {
        setLoading(false);
        setCreateLeadInitialValues(initialValues);
        setAlertMessage?.("Lead saved successfully!");
        setAlertType?.("success");
        setAlertOpen?.(true);
        setTimeout(() => {
          setCreateLeadInitialValues(initialValues);
          updateLeadList();
          props?.onClose();
        }, 100);
      } else {
        setAlertMessage?.("Failed to save lead.");
        setAlertType?.("error");
        setAlertOpen?.(true);
        setLoading?.(false);
      }
    } catch (error: any) {
      setAlertMessage?.(
        error?.response?.data?.message ||
        "An error occurred while creating the lead."
      );
      setAlertType?.("error");
      setAlertOpen?.(true);
      setLoading?.(false);
    }
  };

  const handleHeaderTextOptions = (questionData: any, index: number) => {
    if (questionData?.isShowSection) {
      //if index is 0, then show only we need previous
      if (index === 0) {
        setHeaderTextOptions("Next, Cancel & Retry.");
      }
      if (index > 0) {
        setHeaderTextOptions("Next, Previous, Cancel & Retry.");
      }
      //from question 2 we need save, submit
      if (index === 2) {
        setHeaderTextOptions("Save, Submit, Next, Previous, Cancel & Retry.");
      }
      //after question 2 we need skip also
      if (index > 2) {
        setHeaderTextOptions("Skip, Save, Submit, Next, Previous, Cancel & Retry.");
      }
      //if its last question, we don't need next and skip
      if(index === questionsInformation?.length -1){
        setHeaderTextOptions("Save, Submit, Previous, Cancel & Retry.");
      }
    }
  }

  useEffect(() => {
    if (questionsInformation?.length > 0) {
      const activeIndex = questionsInformation.findIndex((q: any) => q.isShowSection);
      if (activeIndex !== -1) {
        // Start mic for the first visible question
        handleVoiceUpdate(questionsInformation[activeIndex], activeIndex, formRef?.current?.setFieldValue, formRef?.current?.values);
      }
    }
  }, []);

  return (
    <div className="create-lead-popup-overlay">
      <div className="create-lead-popup">
        <div className="create-lead-head">
          <div className="create-lead-head-text">Create Lead - Voice</div>
          <div className="create-lead-head-right-section">
            <div className="create-lead-head-voice-commands-info">
              <img src={infoIcon} alt="Info" className="info-icon" />
                <p className="voice-commands-text">
                  Control with your voice too—<strong>{headerTextOptions}</strong>
                </p>
            </div>
            <div className="create-lead-close-btn">
              <img src={closeIcon} onClick={props?.onClose} alt="Close" />
            </div>
          </div>
        </div>
        <div className="create-lead-section">
          <div className="create-lead-row-section">
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              onSubmit={onSubmit}
              // isValidating={true}
              // setSubmitting={true}
              // isSubmitting={true}
              innerRef={(instance) => {
                if (instance) {
                  (formRef as any).current = instance;
                }
              }}
            >
              {({ setFieldValue, values }) => (
                <Form className="create-lead-form-section">
                  {questionsInformation?.map(
                    (questionData: any, index: number) => {
                     handleHeaderTextOptions(questionData, index);
                      return questionData?.isShowSection ? (
                        <>
                          <div className="create-lead-form-skip-button-section">
                            {!isSpeechRecognition && index >= 1 ? (
                              <div
                                className="create-lead-form-next-button"
                                onClick={() => handlePreviousButtonClick(index)}
                              >
                                <i className="fa fa-arrow-left" /> Previous
                              </div>
                            ) : (
                              ""
                            )}
                            <div></div>
                            {!isSpeechRecognition &&
                            questionData?.question !== "All Done !" ? (
                              <>
                                {questionData?.isRequired ? (
                                  ""
                                ) : questionData?.isShowSkipButton ? (
                                  <div
                                    className="create-lead-form-skip-button"
                                    onClick={() => handleSkipButtonClick(index)}
                                  >
                                    Skip <i className="fa fa-arrow-right" />
                                  </div>
                                ) : (
                                  ""
                                )}
                                  {(questionData?.isShowNextButton && (questionData?.question !== "Q3. What’s your email ?")) ? (
                                  <div
                                    className="create-lead-form-next-button"
                                    onClick={() => handleNextButtonClick(index)}
                                  >
                                    Next <i className="fa fa-arrow-right" />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="create-lead-form-group">
                            <div className="create-lead-form-group-label-section">
                              <div className="create-lead-form-group-label">
                                {questionData?.question}
                              </div>
                            </div>
                            <div className="create-lead-form-group-mic-section">
                              {!isSpeechRecognition ? (
                                <div className="create-lead-form-group-mic">
                                  <i
                                    className="fa fa-microphone-slash "
                                    onClick={() => {
                                      handleVoiceUpdate(
                                        questionData,
                                        index,
                                        setFieldValue,
                                        values,
                                      );
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="create-lead-form-group-mic listening">
                                    <i className="fa fa-microphone "
                                    />
                                </div>
                              )}
                            </div>
                            {(questionData?.question !== "All Done !") ? (
                              <>
                              <div className="create-lead-form-group-response-section">
                                <div className="create-lead-form-group-response-text">
                                  Your Response
                                </div>
                                <div className="create-lead-form-group-response-data">
                                  {questionData?.value}
                                    {questionData?.value && !isSpeechRecognition && <button className="cancel-button retry-button" type="button"
                                      onClick={() => {
                                        setErrorMessage("");
                                        setFieldValue(questionData?.fieldKey, "");
                                        const updatedQuestions = questionsInformation?.map((q: any, i: number) =>
                                          i === index ? { ...q, value: "", isShowNextButton: false } : q
                                        );
                                        setQuestionsInformation(updatedQuestions);
                                        handleVoiceUpdate(
                                          questionData,
                                          index,
                                          setFieldValue,
                                          values,
                                        );
                                      }}>
                                      Retry
                                    </button>}
                                </div>
                              </div>
                              {errorMessage && <div className="error-message">
                                {errorMessage}
                              </div>}
                              </>
                            ) : (
                              ""
                            )}
                            {(questionData?.question === "All Done !" || (questionData?.question === "Q3. What’s your email ?" && questionData?.value)) ? (
                              <div className="create-lead-form-group-recorded-section">
                                {!isSpeechRecognition  && <div className="create-lead-form-group-recorded-text">
                                  <img src={leadDecagramIcons} alt="Close" />{" "}
                                  &nbsp;Your response has been recorded
                                </div>}
                                {!isSpeechRecognition && <div className="create-lead-form-group-recorded-button-wrapper">
                                  <div className="create-lead-form-group-recorded-button">
                                    <button type="submit">Preview</button>
                                  </div>
                                  {
                                    (questionData?.question === "Q3. What’s your email ?" && questionData?.value) &&
                                    <div className="create-lead-form-group-recorded-button">
                                      <button type="button" onClick={() => handleNextButtonClick(index)}>
                                        Fill Other Details
                                      </button>
                                    </div>
                                  }
                                </div>}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      ) : (
                        ""
                      );
                    },
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <ConfirmationPopup
        open={isCancelPopupOpen}
        title="Are you sure you want to cancel?"
        note="All the information you have provided so far will be lost."
        Icon={confirmationIcon}
        showIcon={true}
        onCancel={() => setIsCancelPopupOpen(false)}
        onOkay={() => {
          setIsCancelPopupOpen(false);
          props?.onClose();
        }}
        buttonText="Yes"
        cancelButtonText="No"
        className="create-lead-cancel-popup"
      />
    </div>
  );
};

export default CreateLeadPopup;
